const spoilers = document.querySelectorAll('.catalog-card__spoiler');

const initSpoilers = () => {
  spoilers.forEach((spoiler) => {
    const desc = spoiler.querySelector('.catalog-card__desc');
    const button = spoiler.querySelector('.catalog-card__readmore');

    button.addEventListener('click', () => {
      desc.classList.toggle('catalog-card__desc--opened');
    });
  });
};

export {initSpoilers}; 
